import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReceiptStudentPage } from './receipt-student.page';

const routes: Routes = [
  {
    path: '',
    component: ReceiptStudentPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReceiptStudentPageRoutingModule {}
